import { styled, YStack, GetProps } from 'tamagui'

export const Card = styled(YStack, {
  name: 'Card',
  backgroundColor: '$cardBackground',
  borderRadius: '$5',
  borderWidth: 1,
  borderColor: '$border',
  padding: '$6',
  animation: 'medium',

  hoverStyle: {
    backgroundColor: '$cardBackgroundHover',
    borderColor: '$orangePrimary',
    scale: 1.01,
  },

  variants: {
    variant: {
      default: {},
      elevated: {
        shadowColor: 'rgba(0, 0, 0, 0.3)',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 1,
        shadowRadius: 20,
      },
      highlighted: {
        borderColor: '$orangePrimary',
        borderWidth: 2,
      },
      subtle: {
        backgroundColor: 'transparent',
        borderColor: '$border',
        hoverStyle: {
          backgroundColor: '$backgroundSecondary',
        },
      },
    },

    size: {
      sm: {
        padding: '$4',
        borderRadius: '$4',
      },
      md: {
        padding: '$6',
        borderRadius: '$5',
      },
      lg: {
        padding: '$8',
        borderRadius: '$6',
      },
    },

    interactive: {
      true: {
        cursor: 'pointer',
        pressStyle: {
          scale: 0.99,
        },
      },
    },
  } as const,

  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
})

export type CardProps = GetProps<typeof Card>
